import type { PageLoad } from './$types';
import { AdvertisingPartnerType } from '$houdini';
import { createPartnerBoxmapsStore } from '$lib/services/store/partnerBoxmaps';
import { routesPagename } from '$lib/services/urls/routesPagename';
import { readable } from 'svelte/store';
import { getPageSeoData } from './metas';

export const load = (async (event) => {
	const { lang, searchParams } = await event.parent();
	const { page } = searchParams;
	const seoData = getPageSeoData(event, { lang });
	const seoDataStore = readable(seoData);

	const pagename = routesPagename.ITINERARY_SEARCH;

	const boxmapsForPageStore = createPartnerBoxmapsStore([{
		type: AdvertisingPartnerType.BOOKING,
		context: 'itinerary_search',
	}]);

	return {
		page,
		poisStore: undefined,
		mobileTopButtons: [],
		pagename,
		seoDataStore,
		boxmapsForPageStore,
	};
}) satisfies PageLoad;
